import api from '@zimpel/common/newApi';
import type { Request } from '@zimpel/common/newApi';

type VerifyEmailParams = {
  verificationCode: string;
}

type VerifyEmailResponse = {
  tenantId: number | null;
}

// eslint-disable-next-line import/prefer-default-export
export const verifyEmail: Request<VerifyEmailParams, VerifyEmailResponse> = ({ verificationCode }) => api
  .post(`/api/verify_email/${verificationCode}`);
